export enum AddTextPopUpState {
  DEFAULT_DROPDOWN = 'DEFAULT_DROPDOWN',
  SUBTITLES = 'SUBTITLES',
  AI_SUBTITLES = 'AI_SUBTITLES',
}
